import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface SendEmailCarrierData {
  [key: string]: unknown;
  toEmail?: string;
}

export const sendEmailCarrierAPI = (data: SendEmailCarrierData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.LOSS_AND_DAMAGE}/SendMailToTransportationProvider`,
  });
};

export type SendEmailCarrierResponse = unknown;

export const sendEmailCarrier = async (data: SendEmailCarrierData): Promise<SendEmailCarrierResponse> => {
  const response: AxiosResponse<SendEmailCarrierResponse> = await sendEmailCarrierAPI(data);
  return response.data;
};
